import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, unref as _unref, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, resolveDynamicComponent as _resolveDynamicComponent, Fragment as _Fragment, createVNode as _createVNode, setBlockTracking as _setBlockTracking, normalizeClass as _normalizeClass, renderList as _renderList, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = ["data-productid", "data-page"]
const _hoisted_2 = { class: "product-image-container" }
const _hoisted_3 = { class: "image-bounds" }
const _hoisted_4 = {
  key: 6,
  class: "discount-badge"
}
const _hoisted_5 = { class: "product-details-container" }
const _hoisted_6 = {
  key: 0,
  class: "time-container"
}
const _hoisted_7 = { class: "time-header" }
const _hoisted_8 = { class: "time-blocks" }
const _hoisted_9 = {
  key: 1,
  class: "amounts auction-amounts"
}
const _hoisted_10 = {
  key: 0,
  class: "bid-amount"
}
const _hoisted_11 = { class: "value-amount" }
const _hoisted_12 = {
  key: 2,
  class: "amounts"
}
const _hoisted_13 = {
  key: 0,
  class: "shop-amount"
}
const _hoisted_14 = {
  key: 1,
  class: "value-amount line-through"
}
const _hoisted_15 = { class: "call-to-action" }
const _hoisted_16 = ["disabled"]
const _hoisted_17 = {
  key: 0,
  class: /*@__PURE__*/_normalizeClass(['success-text'])
}
const _hoisted_18 = ["href"]
const _hoisted_19 = {
  key: 0,
  class: "follow-action"
}

import {
    getDateParts,
    isValidSecondsleft,
} from "../../../../../commons/product/auction/countdown";
import { formatAmount } from "../common";
import labels from "../../../../shared/labels";
import ImageOverlay from "../../../../../commons/product/overlays/image-overlay.vue";
import {
    type TrackingInformation,
    storeLinkTrackingInformation,
} from "../../../../../../utilities/product-link-tracking";
import {
    type PropType,
    ref,
    onMounted,
    watch,
    computed,
    onBeforeUnmount,
} from "vue";
import productImage from "../common/product-image.vue";
import timePart from "./time-part.vue";
import { type IProductPictureInfo } from "../../list-item";
import { TimeDuration } from "@and3k5/timespan.js";
import {
    format,
    isNullOrEmpty,
    isNullOrWhitespace,
    undefinedIfNullOrWhiteSpace,
} from "../../../../../../shared/utils/string";
import fallbackImage from "../../../../frontend-productpage/fallback-image.jpg?file";
import FollowButton from "../common/follow-button.vue";
import { type TimeParts } from "../../../../../commons/product/auction/countdown/types";
import FadeAndSlide from "../../../../shared/FadeAndSlide.vue";
import axios from "axios";
import {
    type AddToCartResponse,
    afterAddToCart,
} from "../../../../frontend-productpage/shop/cart-adding";
import { type OverwriteSettings } from "../../../../../commons/product/overwrite-settings";
import Filler from "../../../../shared/Filler.vue";
import {
    ensureInitializedRegistration,
    type ProductRegistrationResult,
} from "../common/product-updater";


const __default__ = {
    model: {
        prop: "item",
    },
};

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  __name: 'product',
  props: {
    isGalleryItem: Boolean,
    productId: Number,
    productName: String,
    link: String,
    overlayText: String,
    overlayTextType: String,
    thirdPartyStamp: Boolean,
    relatedAuctionStamp: Boolean,
    relatedShopStamp: Boolean,
    mobile: Boolean,
    forceLazyLoadImage: Boolean,
    secondsLeft: Number,
    indexOfList: Number,
    timeIsNotStarted: Boolean,
    imageInfo: Object as PropType<IProductPictureInfo>,
    page: Number,
    isAuction: Boolean,
    isShop: Boolean,
    isBuynow: Boolean,
    trackingInfo: Object as PropType<TrackingInformation>,
    productValue: Number,
    hasBid: Boolean,
    price: Number,
    scaleOfScreen: {
        type: Number,
        default: 1,
    },
    overwriteActionButtonText: String,
    overwriteActionButton: Boolean,
    overwriteSettings: Object as PropType<OverwriteSettings>,
    actionButtonLoading: Boolean,
    expectedContentType: String,
    visible: {
        type: Boolean,
        default: true,
    },
    registration: Object as PropType<ProductRegistrationResult>,
},
  emits: [
    "action-button-click",
    "update:productId",
    "update:productName",
    "update:link",
    "update:overlayText",
    "update:overlayTextType",
    "update:thirdPartyStamp",
    "update:relatedAuctionStamp",
    "update:relatedShopStamp",
    "update:secondsLeft",
    "update:timeIsNotStarted",
    "update:isAuction",
    "update:isShop",
    "update:isBuynow",
    "update:productValue",
    "update:hasBid",
    "update:price",
    "mounted",
    "unmount",
],
  setup(__props, { emit: __emit }) {

const emit = __emit;

const cartLink = ref<string>();

const props = __props;

const timeLabel = computed(() => {
    if (props.isShop) {
        if (props.timeIsNotStarted)
            return labels.frontendProductList.productSpecs.headers
                .timeLeftToStart_shop;
        else
            return labels.frontendProductList.productSpecs.headers
                .timeLeft_shop;
    }
    if (props.timeIsNotStarted)
        return labels.frontendProductList.productSpecs.headers.timeLeftToStart;
    else return labels.frontendProductList.productSpecs.headers.timeLeft;
});

function mapLabels(value: string[]) {
    return value.map((x: string, i: number, a: string[]) => ({
        i: i,
        txt: x,
        a: a,
    }));
}

const duration = new TimeDuration(0);
const timeParts = ref<TimeParts>({
    days: {
        unit: "\u00a0",
        value: undefined,
    },
    hours: {
        unit: "\u00a0",
        value: undefined,
    },
    minutes: {
        unit: "\u00a0",
        value: undefined,
    },
    seconds: {
        unit: "\u00a0",
        value: undefined,
    },
});
const internalActionButtonLoading = ref(false);

const imgInfo = computed(() => {
    if (props.imageInfo == null) return props.imageInfo;
    if (props.imageInfo.pictureUrl != null) return props.imageInfo;
    const res: IProductPictureInfo = {
        pictureUrl: fallbackImage,
        pictureWidth: 470,
        pictureHeight: 353,
        pictureSrcSet: undefined,
        pictureSrcSetAsWebp: undefined,
        pictureUrlAsWebp: undefined,
    };
    return res;
});

watch(
    () => props.secondsLeft,
    (newValue, oldValue) => {
        if (props.visible != true) return;
        if (props.productId == null) return;
        if (newValue != null) {
            if (oldValue != null && ~~newValue == ~~oldValue) return;
            updateSecondsData(newValue);
        }
    },
    {
        immediate: true,
    }
);

watch(
    () => props.visible,
    (newValue, oldValue) => {
        if (newValue && !oldValue) {
            if (props.productId == null) {
                // console.debug("would get seconds but productid missing");
                return;
            }
            if (props.secondsLeft == null) {
                // console.debug("would get seconds but secondsLeft missing");
                return;
            }
            updateSecondsData(props.secondsLeft);
        } else {
            // console.log(`visible ${oldValue} => ${newValue}`);
        }
    }
);

function updateSecondsData(newValue: number) {
    duration.setTotalSeconds(newValue);
    timeParts.value = getDateParts(
        duration,
        labels.frontendProductList.productSpecs.time
    );
}

const addToCartAction = computed(() => {
    if (props.isShop !== true) {
        return false;
    }
    return true;
});

const compActionButtonLoading = computed(
    () => internalActionButtonLoading.value || props.actionButtonLoading
);

const actionButtonText = computed(() => {
    if (props.productId == null) {
        return "\u00a0";
    }
    if (addToCartAction.value) {
        return labels.frontendProductpage.specs.addToCart;
    }
    if (
        props.isShop &&
        !isNullOrEmpty(
            labels.frontendProductList.productSpecs.actionTexts.makeOffer_shop
        )
    )
        return labels.frontendProductList.productSpecs.actionTexts
            .makeOffer_shop;
    else if (
        props.isBuynow &&
        !isNullOrEmpty(
            labels.frontendProductList.productSpecs.actionTexts.makeOffer_buyNow
        )
    )
        return labels.frontendProductList.productSpecs.actionTexts
            .makeOffer_buyNow;
    else return labels.frontendProductList.productSpecs.actionTexts.makerOffer;
});

async function clickEvent(ev: Event) {
    if (props.productId == null) {
        ev.preventDefault();
        return;
    }
    if (addToCartAction.value) {
        ev.preventDefault();
        internalActionButtonLoading.value = true;
        try {
            const response = await axios.post<AddToCartResponse>(
                "/auctionProduct/addToCart",
                undefined,
                {
                    params: {
                        productId: props.productId,
                        orderQuantity: 1,
                    },
                }
            );
            if (response.data.success !== true) {
                throw new Error(response.data.errors.join("\n"));
            }

            afterAddToCart(
                props.productId,
                response.data.cartItemsCount,
                response.data.firstAdd
            );

            cartLink.value = response.data.cartLink;

            return;
        } finally {
            internalActionButtonLoading.value = false;
        }
    }
}

const el = ref<HTMLLIElement>();

onMounted(() => {
    emit("mounted", el.value);
    ensureInitializedRegistration(props, emit);

    if (el.value == null) throw new Error("missing ref");
    if (props.trackingInfo != null) {
        // console.debug("storeLinkTrackingInformation");
        storeLinkTrackingInformation(el.value, props.trackingInfo);
    }
});

onBeforeUnmount(() => {
    emit("unmount", el.value);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("li", {
    ref_key: "el",
    ref: el,
    "data-productid": __props.productId,
    class: _normalizeClass([
            'product-item',
            __props.mobile ? 'forced-mobile' : '',
            __props.isGalleryItem ? 'gallery-item' : '',
        ]),
    "data-item-type": "product",
    "data-page": __props.page,
    key: __props.productId
  }, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(), _createBlock(_resolveDynamicComponent(__props.link != null && __props.link != '' ? 'a' : 'span'), {
        href: __props.link,
        class: "product-image",
        "data-product-link": ""
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            (imgInfo.value == null)
              ? (_openBlock(), _createBlock(Filler, {
                  key: 0,
                  box: "",
                  "aspect-ratio": "4/3"
                }))
              : (_openBlock(), _createBlock(productImage, {
                  key: 1,
                  "scale-of-screen": __props.scaleOfScreen,
                  item: imgInfo.value,
                  "fixed-width": __props.isGalleryItem ? undefined : undefined,
                  "provided-image-width": __props.isGalleryItem ? 230 : undefined,
                  "fill-width": "",
                  lazy: 
                            __props.forceLazyLoadImage ||
                            __props.indexOfList == null ||
                            __props.indexOfList > 4
                        ,
                  "fallback-width": "700",
                  "fallback-height": "525",
                  "fallback-aspect-ratio": "4/3"
                }, null, 8 /* PROPS */, ["scale-of-screen", "item", "fixed-width", "provided-image-width", "lazy"])),
            (__props.overlayText != null)
              ? (_openBlock(), _createBlock(ImageOverlay, {
                  type: __props.overlayTextType,
                  key: __props.overlayTextType
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(__props.overlayText), 1 /* TEXT */)
                  ], undefined, true),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["type"]))
              : _createCommentVNode("v-if", true),
            (__props.thirdPartyStamp)
              ? (_openBlock(), _createBlock(ImageOverlay, {
                  type: "third-party-stamp",
                  key: "third-party-stamp"
                }))
              : _createCommentVNode("v-if", true),
            (__props.relatedAuctionStamp)
              ? (_openBlock(), _createBlock(ImageOverlay, {
                  type: "related-auction",
                  key: "related-auction"
                }))
              : _createCommentVNode("v-if", true),
            (__props.relatedShopStamp)
              ? (_openBlock(), _createBlock(ImageOverlay, {
                  type: "related-shop",
                  key: "related-shop"
                }))
              : _createCommentVNode("v-if", true),
            (
                            __props.isShop &&
                            __props.productValue != null &&
                            __props.price != null &&
                            __props.productValue > __props.price &&
                            Math.round((1 - __props.price / __props.productValue) * 100) >= 10
                        )
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_unref(format)(
                                _unref(labels).frontendProductList.discount,
                                Math.round((1 - __props.price / __props.productValue) * 100) +
                                    "%"
                            )), 1 /* TEXT */))
              : _createCommentVNode("v-if", true),
            (__props.mobile && __props.isAuction && __props.productId != null)
              ? (_openBlock(), _createBlock(FollowButton, {
                  key: 7,
                  class: "follow-action-floating",
                  "product-id": __props.productId
                }, null, 8 /* PROPS */, ["product-id"]))
              : _createCommentVNode("v-if", true)
          ])
        ], undefined, true),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["href"]))
    ]),
    _createElementVNode("div", _hoisted_5, [
      (
                    (__props.productId == null && __props.expectedContentType != 'shop') ||
                    (__props.secondsLeft != null && _unref(isValidSecondsleft)(__props.secondsLeft))
                )
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("span", _hoisted_7, [
              (__props.productId == null)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(" ")
                  ], 64 /* STABLE_FRAGMENT */))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createTextVNode(_toDisplayString(timeLabel.value), 1 /* TEXT */)
                  ], 64 /* STABLE_FRAGMENT */))
            ]),
            _createElementVNode("div", _hoisted_8, [
              (__props.secondsLeft != null)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createVNode(timePart, {
                      "forced-mobile": __props.mobile,
                      value: 
                                __props.secondsLeft == null
                                    ? undefined
                                    : __props.secondsLeft > 0
                                    ? timeParts.value.days.value
                                    : 0
                            ,
                      unit: timeParts.value.days.unit
                    }, null, 8 /* PROPS */, ["forced-mobile", "value", "unit"]),
                    _cache[3] || (_cache[3] = _createElementVNode("span", { class: "time-block-separator" }, null, -1 /* HOISTED */)),
                    _createVNode(timePart, {
                      "forced-mobile": __props.mobile,
                      value: 
                                __props.secondsLeft == null
                                    ? undefined
                                    : __props.secondsLeft > 0
                                    ? timeParts.value.hours.value
                                    : 0
                            ,
                      unit: timeParts.value.hours.unit
                    }, null, 8 /* PROPS */, ["forced-mobile", "value", "unit"]),
                    _cache[4] || (_cache[4] = _createElementVNode("span", { class: "time-block-separator" }, null, -1 /* HOISTED */)),
                    _createVNode(timePart, {
                      "forced-mobile": __props.mobile,
                      value: 
                                __props.secondsLeft == null
                                    ? undefined
                                    : __props.secondsLeft > 0
                                    ? timeParts.value.minutes.value
                                    : 0
                            ,
                      unit: timeParts.value.minutes.unit
                    }, null, 8 /* PROPS */, ["forced-mobile", "value", "unit"]),
                    _cache[5] || (_cache[5] = _createElementVNode("span", { class: "time-block-separator" }, null, -1 /* HOISTED */)),
                    _createVNode(timePart, {
                      "forced-mobile": __props.mobile,
                      value: 
                                __props.secondsLeft == null
                                    ? undefined
                                    : __props.secondsLeft > 0
                                    ? timeParts.value.seconds.value
                                    : 0
                            ,
                      unit: timeParts.value.seconds.unit
                    }, null, 8 /* PROPS */, ["forced-mobile", "value", "unit"])
                  ], 64 /* STABLE_FRAGMENT */))
                : _createCommentVNode("v-if", true)
            ])
          ]))
        : _createCommentVNode("v-if", true),
      _cache[6] || (_cache[6] = _createElementVNode("hr", { class: "name-top-line" }, null, -1 /* HOISTED */)),
      _cache[0] || (
        _setBlockTracking(-1, true),
        (_cache[0] = (_openBlock(), _createBlock(_resolveDynamicComponent(__props.link != null && __props.link != '' ? 'a' : 'span'), {
          class: "product-title",
          href: __props.link,
          "data-product-link": ""
        }, {
          default: _withCtx(() => [
            (__props.productId == null)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  (__props.productName == null)
                    ? (_openBlock(), _createBlock(Filler, {
                        key: 0,
                        max: 70
                      }))
                    : _createCommentVNode("v-if", true)
                ], 64 /* STABLE_FRAGMENT */))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createTextVNode(_toDisplayString(__props.productName), 1 /* TEXT */)
                ], 64 /* STABLE_FRAGMENT */))
          ], undefined, true),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["href"]))).cacheIndex = 0,
        _setBlockTracking(1),
        _cache[0]
      ),
      _cache[7] || (_cache[7] = _createElementVNode("hr", { class: "name-bottom-line" }, null, -1 /* HOISTED */)),
      (__props.isAuction || __props.productId == null)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            (__props.price != null || __props.productId == null)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  (__props.productId == null)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createTextVNode(" ")
                      ], 64 /* STABLE_FRAGMENT */))
                    : (!__props.hasBid)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createTextVNode(_toDisplayString(_unref(labels).frontendProductList.productSpecs.headers
                                .minimumPrice) + ": ", 1 /* TEXT */)
                        ], 64 /* STABLE_FRAGMENT */))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                          _createTextVNode(_toDisplayString(_unref(labels).frontendProductList.productSpecs.headers
                                .currentBid) + ": ", 1 /* TEXT */)
                        ], 64 /* STABLE_FRAGMENT */)),
                  (__props.productId == null || __props.price == null)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                        _createTextVNode(" ")
                      ], 64 /* STABLE_FRAGMENT */))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                        _createTextVNode(_toDisplayString(_unref(formatAmount)(__props.price)), 1 /* TEXT */)
                      ], 64 /* STABLE_FRAGMENT */))
                ]))
              : _createCommentVNode("v-if", true),
            _createElementVNode("div", _hoisted_11, [
              (__props.productValue == null || __props.productId == null)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(" ")
                  ], 64 /* STABLE_FRAGMENT */))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createTextVNode(_toDisplayString(_unref(undefinedIfNullOrWhiteSpace)(
                                __props.overwriteSettings?.overwriteEstimateLabel
                            ) ??
                            _unref(labels).frontendProductList.productSpecs.headers
                                .estimatedValue) + ": ", 1 /* TEXT */)
                  ], 64 /* STABLE_FRAGMENT */)),
              (__props.productId == null || __props.productValue == null)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                    _createTextVNode(" ")
                  ], 64 /* STABLE_FRAGMENT */))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                    _createTextVNode(_toDisplayString(_unref(formatAmount)(__props.productValue)), 1 /* TEXT */)
                  ], 64 /* STABLE_FRAGMENT */))
            ])
          ]))
        : (__props.isShop)
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
              (__props.price != null)
                ? (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString(_unref(formatAmount)(__props.price)), 1 /* TEXT */))
                : _createCommentVNode("v-if", true),
              (
                        __props.productValue != null &&
                        (__props.price == null || __props.productValue > __props.price)
                    )
                ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                    (
                            __props.productValue != null &&
                            (__props.price == null || __props.productValue > __props.price)
                        )
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createTextVNode(_toDisplayString(_unref(undefinedIfNullOrWhiteSpace)(
                                __props.overwriteSettings?.overwriteEstimateLabel
                            ) ??
                            _unref(labels).frontendProductList.productSpecs.headers
                                .shopEstimatedPrice) + ": " + _toDisplayString(_unref(formatAmount)(__props.productValue)), 1 /* TEXT */)
                        ], 64 /* STABLE_FRAGMENT */))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createTextVNode(" ")
                        ], 64 /* STABLE_FRAGMENT */))
                  ]))
                : _createCommentVNode("v-if", true)
            ]))
          : _createCommentVNode("v-if", true),
      (
                    __props.isAuction ||
                    __props.isShop ||
                    __props.isBuynow ||
                    __props.overwriteActionButton ||
                    __props.productId == null
                )
        ? (_openBlock(), _createElementBlock("div", {
            key: 3,
            class: _normalizeClass([
                    'actions-container',
                    __props.isAuction ? 'auction-actions-container' : '',
                ])
          }, [
            _createElementVNode("div", _hoisted_15, [
              (__props.overwriteActionButton)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    type: "button",
                    class: _normalizeClass([
                            'action-button',
                            compActionButtonLoading.value ? 'loading' : '',
                        ]),
                    disabled: compActionButtonLoading.value,
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('action-button-click', $event)))
                  }, _toDisplayString(__props.overwriteActionButtonText), 11 /* TEXT, CLASS, PROPS */, _hoisted_16))
                : (_openBlock(), _createBlock(_resolveDynamicComponent(__props.link != null && __props.link != '' ? 'a' : 'span'), {
                    key: 1,
                    class: _normalizeClass([
                            'action-button',
                            compActionButtonLoading.value ? 'loading' : '',
                        ]),
                    href: __props.link ?? (addToCartAction.value ? undefined : '#'),
                    "data-product-link": "",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (clickEvent($event)))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(actionButtonText.value), 1 /* TEXT */)
                    ], undefined, true),
                    _: 1 /* STABLE */
                  }, 8 /* PROPS */, ["class", "href"])),
              _createVNode(FadeAndSlide, null, {
                default: _withCtx(() => [
                  (
                                !_unref(isNullOrWhitespace)(cartLink.value) &&
                                cartLink.value != null
                            )
                    ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(mapLabels(
                                    _unref(labels).frontendProductpage.specs.addedToCart.split(
                                        '{0}'
                                    )
                                ), (textPart) => {
                          return (_openBlock(), _createElementBlock(_Fragment, null, [
                            _createTextVNode(_toDisplayString(textPart.txt), 1 /* TEXT */),
                            (textPart.i != textPart.a.length - 1)
                              ? (_openBlock(), _createElementBlock("a", {
                                  key: 0,
                                  href: cartLink.value,
                                  class: _normalizeClass(['cart-link'])
                                }, _toDisplayString(_unref(labels).frontendProductpage.specs
                                            .addedToCartName), 9 /* TEXT, PROPS */, _hoisted_18))
                              : _createCommentVNode("v-if", true)
                          ], 64 /* STABLE_FRAGMENT */))
                        }), 256 /* UNKEYED_FRAGMENT */))
                      ]))
                    : _createCommentVNode("v-if", true)
                ], undefined, true),
                _: 1 /* STABLE */
              })
            ]),
            (!__props.mobile && __props.isAuction && __props.productId != null)
              ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                  _createVNode(FollowButton, { "product-id": __props.productId }, null, 8 /* PROPS */, ["product-id"])
                ]))
              : _createCommentVNode("v-if", true)
          ], 2 /* CLASS */))
        : _createCommentVNode("v-if", true)
    ]),
    _renderSlot(_ctx.$slots, "default")
  ], 10 /* CLASS, PROPS */, _hoisted_1))
}
}

})